import { Box, Dialog, DialogContent, Grid } from "@mui/material"
import GiftRules from "./GiftRules"
import IntroduceAndNote from "./IntroduceAndNote"
import IntroduceSectionCloseButton from "../IntroduceSectionCloseButton"
import { Button } from "src/shared"
import { useState } from "react"

type IntructionTypeState = "introduce" | "rule" | "none"

const Introduce = () => {
  const [introduceState, setIntroduceState] =
    useState<IntructionTypeState>("none")
  const handleShowIntroduce = (type: string) =>
    setIntroduceState(type as IntructionTypeState)

  const isOpenDialog =
    introduceState === "introduce" || introduceState === "rule"
  return (
    <>
      <Grid container gap={2.5} justifyContent="center" alignItems="center">
        <Button onClick={() => handleShowIntroduce("rule")}>Thể lệ</Button>
        <Button onClick={() => handleShowIntroduce("introduce")}>
          Hướng dẫn
        </Button>
      </Grid>
      {isOpenDialog && (
        <Dialog
          sx={theme => ({
            "& .MuiDialog-paper": {
              overflowY: "hidden",
              height: "auto",
              borderRadius: "16px",
              background:
                "linear-gradient(#5ed3db,#85d5d2,#b1d8c9,#d2dac3,#ebdbbe,#f9dcbb,#ffddba)",
              [theme.breakpoints.down(600)]: {
                margin: theme.spacing(0, 2),
              },
            },
          })}
          open={isOpenDialog}
        >
          <IntroduceSectionCloseButton
            onClick={e => {
              e.stopPropagation()
              setIntroduceState("none")
            }}
          />
          <DialogContent
            sx={theme => ({
              paddingTop: 4,
              padding: "32px 24px",
              [theme.breakpoints.down(600)]: {
                padding: "32px 16px",
              },
            })}
          >
            <Box mb={7} width="100%" textAlign="center">
              <img src="/assets/images/kitchen_logo.png" alt="logo" />
            </Box>
            {introduceState === "introduce" ? (
              <IntroduceAndNote />
            ) : (
              <GiftRules />
            )}
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}

export default Introduce
